import { Injectable, NgModule } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppSettings } from './appsettings.model';
import { AppSettingsService } from './appsettings.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [AppSettingsService],
})
export class SettingsService {
  public static config: [{ key; value }];

  constructor(public appSettings: AppSettingsService) {
    this.setDefaults();
  }

  private static getConfig() {
    if (SettingsService.config == null) {
      SettingsService.config = SettingsService.getDataSynchronous();
    }

    return SettingsService.config;
  }

  private setDefaults() {
    const config = SettingsService.getConfig();

    if (!config) {
      return;
    }

    let publicUrl = config.find((k) => k.key == 'PublicUrl')?.value;
    let scheme = config.find((k) => k.key == 'Scheme')?.value;
    environment.publicUrl = '.' + publicUrl;
    environment.reCaptchaSiteKey = config.find(
      (k) => k.key == 'PublicCaptchaSiteKey'
    )?.value;

    const appUrl = publicUrl + this.appSettings.settings.rootUrl;
    let orgCodePlaceholder = '{org_code}.';
    environment.azureLoginUri = config.find((k) => k.key == 'PublicAzureLoginUri')?.value;
    environment.azureRedirect = scheme + '://' + publicUrl + environment.azureRedirect;
    environment.contactUrl = config.find((k) => k.key == 'PublicContactUrl')?.value;

    environment.googleDirectoryAllowedOrigin = scheme + '://' + publicUrl;
    environment.downloadLocal = config.find((k) => k.key == 'DownloadLocal')?.value;

    environment.downloadcookie_domain = publicUrl;

    let singleTenant = config.find((k) => k.key == 'SingleTenant')?.value;
    if (singleTenant && singleTenant.length > 0) {
      environment.singleTenantMode = true;
      environment.organizationCode = singleTenant;
      orgCodePlaceholder = '';
    } else {
      environment.singleTenantMode = false;
    }

    var value = config.find( v=> v.key == "Environment")?.value ?? 'Production';
    switch (value) {
      case 'Development':
        environment.production = false;
        environment.organization = scheme + '://' + publicUrl + '/api/organization';
        environment.user = scheme +'://' + publicUrl + '/api/user';
        environment.master = scheme +'://' + publicUrl + '/api/master';
        environment.activityLogging = scheme +'://' + publicUrl + '/api/activitylogging';
        environment.analytics = scheme +'://' + publicUrl + '/api/analytics';
        environment.filestore = scheme +'://' + publicUrl + '/api/filestore';
        environment.notification = scheme +'://' + publicUrl + '/notification';
        environment.conditionalAccess = scheme +'://' + publicUrl + '/api/conditionalaccess';
        environment.identity = scheme +'://' + publicUrl + '/identity';
        environment.migration = scheme +'://' + publicUrl + '/api/migration';
        environment.report = scheme +'://' + publicUrl + '/api/report';
        environment.anomalydetection = scheme +'://' + publicUrl + '/api/anomalydetection';

        environment.identityApi = scheme +'://' + publicUrl + '/identity';
        environment.identityRedirect = scheme +'://' + appUrl + '/auth-callback?subDomain=' + environment.organizationCode;
        environment.identityChangePassword = scheme +'://' + appUrl + '/auth-callback?subDomain=' + environment.organizationCode + '&changePassword=true';;
        environment.identityLogout = scheme +'://' + appUrl + '/authentication/logout?subDomain =' + environment.organizationCode;
        environment.identitySilentRedirect = scheme +'://' + appUrl + '/assets/silent-renew.html?subDomain=' + environment.organizationCode;
        environment.identityInitiatedUrl = scheme +'://' + publicUrl + '/identity/saml2?app=$app_id$&ServiceProvider=$thirdPartyEntityId$&AssertConsumerUrl=$thirdPartySignInUrl$';
        break;
      case 'OnPremises':
        environment.organization = scheme +'://' + publicUrl + ':3002';
        environment.user = scheme +'://' + publicUrl + ':3005';
        environment.master = scheme +'://' + publicUrl + ':3004';
        environment.activityLogging = scheme +'://' + publicUrl + ':3001';
        environment.analytics = scheme +'://' + publicUrl + ':3008';
        environment.filestore = scheme +'://' + publicUrl + ':3011';
        environment.notification = scheme +'://' + publicUrl + ':3007';
        environment.conditionalAccess = scheme +'://' + publicUrl + ':3006';
        environment.identity = scheme +'://' + orgCodePlaceholder + publicUrl + '/identity';
        environment.migration = scheme +'://' + publicUrl + ':3012';
  
        environment.identityApi = environment.identity;
        environment.identityRedirect = scheme +'://' + orgCodePlaceholder + appUrl + '/auth-callback';
        environment.identityChangePassword = scheme +'://' + orgCodePlaceholder + appUrl + '/auth-callback&changePassword=true';
        environment.identityLogout = scheme +'://' + orgCodePlaceholder + appUrl + '/authentication/logout';
        environment.identitySilentRedirect = scheme +'://' + orgCodePlaceholder + appUrl + '/assets/silent-renew.html';
        environment.identityInitiatedUrl = environment.identity + '/saml2?app=$app_id$&ServiceProvider=$thirdPartyEntityId$&AssertConsumerUrl=$thirdPartySignInUrl$';
            
        break;
    
      case 'Production':
      case 'Windows':
        environment.organization = scheme +'://' + publicUrl + '/api/organization';
        environment.user = scheme +'://' + publicUrl + '/api/user';
        environment.master = scheme +'://' + publicUrl + '/api/master';
        environment.activityLogging = scheme +'://' + publicUrl + '/api/activitylogging';
        environment.analytics = scheme +'://' + publicUrl + '/api/analytics';
        environment.filestore = scheme +'://' + publicUrl + '/api/filestore';
        environment.notification = scheme +'://' + publicUrl + '/notification';
        environment.conditionalAccess = scheme +'://' + publicUrl + '/api/conditionalaccess';
        environment.identity = scheme +'://' + orgCodePlaceholder + publicUrl + '/identity';
        environment.migration = scheme +'://' + publicUrl + '/api/migration';
        environment.report = scheme +'://' + publicUrl + '/api/report';
        environment.anomalydetection = scheme +'://' + publicUrl + '/api/anomalydetection';
  
        environment.identityApi = scheme +'://' + orgCodePlaceholder + publicUrl + '/identity';
        environment.identityRedirect = scheme +'://' + orgCodePlaceholder + appUrl + '/auth-callback';
        environment.identityChangePassword = scheme +'://' + orgCodePlaceholder + appUrl + '/auth-callback&changePassword=true';
        environment.identityLogout = scheme +'://' + orgCodePlaceholder + appUrl + '/authentication/logout';
        environment.identitySilentRedirect = scheme +'://' + orgCodePlaceholder + appUrl + '/assets/silent-renew.html';
        environment.identityInitiatedUrl = scheme +'://' + orgCodePlaceholder + publicUrl + '/identity/saml2?app=$app_id$&ServiceProvider=$thirdPartyEntityId$&AssertConsumerUrl=$thirdPartySignInUrl$';
  
        break;
    }

  }

  static getDataSynchronous() {
    try {
          var request = new XMLHttpRequest();
          request.open('GET', '/settings', false);
      
          request.send();
      
          if (request.status === 200) {
            return JSON.parse(request.response);
          }
    } catch (error) {
      console.log('Error getting settings', error);
    }
  }
}
